import styled from '@emotion/styled';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';

export const FilterPillsContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  gap: ${SPACING.XS};
  margin-top: ${SPACING.S16};

  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const FilterPillClearAll = styled.span`
  font-weight: ${FONT.WEIGHT.BOLD};
  ${FONT.textSizeCompact(FONT.SIZE.SMALLER)}
  text-decoration-line: underline;
`;
